<header class="topbar">
  <div
    #selecteur
    class="page-title"
    [style.visibility]="afficherParc() ? null : 'hidden'"
    (keydown.escape)="fermerListe(true)"
  >
    <button
      type="button"
      class="parc-home"
      aria-label="Revenir au parc global"
      title="Revenir au parc global"
      (click)="selectionnerParcGlobal()"
    >
      <span class="material-symbols-outlined" aria-hidden="true">holiday_village</span>
    </button>
    <div class="title-group">
      <h1>
        @if (installationId() !== null) {
          <a class="parc-name parc-parent" routerLink="/parc" (click)="fermerListe()"
            >Parc {{ parcSelectionne()?.libelle ?? '…' }}</a
          >
        } @else {
          <span class="parc-name">Parc {{ parcSelectionne()?.libelle ?? '…' }}</span>
        }
        @if (installationSelectionnee(); as installation) {
          <span class="title-separator" aria-hidden="true">›</span>
          <span #installationNom class="installation-name" [title]="installation.nom">{{
            installation.nom
          }}</span>
        }
      </h1>
    </div>
    <button
      #listeToggle
      type="button"
      class="ghost-icon"
      [class.open]="listeOuverte()"
      [attr.aria-label]="
        installationId() !== null
          ? 'Afficher la liste des installations'
          : 'Afficher la liste des parcs'
      "
      [attr.aria-expanded]="listeOuverte()"
      [attr.aria-controls]="listeOuverte() ? 'toolbar-liste' : null"
      (click)="toggleListe()"
    >
      <span aria-hidden="true"></span>
    </button>

    @if (listeOuverte()) {
      <nav
        id="toolbar-liste"
        class="parc-dropdown"
        [class.installation-dropdown]="installationId() !== null"
        [style.left.px]="positionListe()?.gauche ?? null"
        [style.max-width.px]="positionListe()?.largeurMax ?? null"
        [attr.aria-label]="installationId() !== null ? 'Installations du parc' : 'Parcs'"
      >
        @if (installationId() !== null) {
          <div class="installation-recherche">
            <span class="material-symbols-outlined" aria-hidden="true">search</span>
            <input
              #rechercheInstallation
              type="search"
              aria-label="Rechercher une installation par nom ou identifiant"
              aria-controls="toolbar-installations"
              placeholder="Nom ou identifiant…"
              autocomplete="off"
              [value]="rechercheInstallations()"
              (input)="rechercheInstallations.set(rechercheInstallation.value)"
            />
            @if (rechercheInstallations()) {
              <button
                type="button"
                class="installation-recherche-effacer"
                aria-label="Effacer la recherche d’installation"
                (click)="effacerRechercheInstallations()"
              >
                <span class="material-symbols-outlined" aria-hidden="true">close</span>
              </button>
            }
          </div>
          <div id="toolbar-installations" class="installation-options">
            @for (installation of installationsFiltrees(); track installation.id) {
              <a
                class="parc-option installation-option"
                [class.active]="installation.id === installationId()"
                [attr.aria-current]="installation.id === installationId() ? 'true' : null"
                [routerLink]="lienInstallation(installation.id)"
                (click)="fermerListe(true)"
              >
                <span
                  class="installation-etat"
                  role="img"
                  [style.background-color]="installation.etat?.couleur || '#6f746f'"
                  [attr.aria-label]="'État : ' + statusLabel(installation.etat)"
                  [title]="statusLabel(installation.etat)"
                ></span>
                <span class="installation-option-nom">{{ installation.nom }}</span>
              </a>
            } @empty {
              <p class="liste-vide" role="status">
                {{
                  installations().length === 0
                    ? 'Aucune installation disponible dans ce parc.'
                    : 'Aucune installation ne correspond à la recherche.'
                }}
              </p>
            }
          </div>
        } @else {
          @for (parc of parcs(); track parc.id) {
            <button
              type="button"
              class="parc-option"
              [class.active]="parc.id === parcSelectionne()?.id"
              (click)="selectionner(parc)"
            >
              <span class="material-symbols-outlined" aria-hidden="true">{{
                parc.global ? 'travel_explore' : 'solar_power'
              }}</span>
              Parc {{ parc.libelle }}
              <span class="parc-count">{{ parc.nbInstallations }}</span>
            </button>
          }
          <button
            type="button"
            class="parc-option creer-parc"
            [disabled]="creationOuverte()"
            (click)="ouvrirCreationParc()"
          >
            <span class="material-symbols-outlined" aria-hidden="true">add</span>
            Créer un parc supplémentaire
          </button>
        }
      </nav>
    }
  </div>

  <div class="topbar-actions">
    <label
      class="searchbox"
      aria-label="Recherche"
      [style.visibility]="afficherParc() ? null : 'hidden'"
    >
      <input type="search" placeholder="Rechercher" />
      <span class="search-icon"></span>
    </label>
    <button
      type="button"
      class="icon-button notification-button"
      [attr.aria-label]="
        'Ouvrir la synthèse des nouveautés' +
        (synthese.totalNouveautes() === null
          ? ''
          : ' — ' + synthese.totalNouveautes() + ' nouveautés')
      "
      aria-haspopup="dialog"
      (click)="synthese.ouvrir()"
    >
      <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
      @if (synthese.totalNouveautes() !== null) {
        <span
          class="notification-badge"
          aria-hidden="true"
          [title]="synthese.totalNouveautes() + ' nouveautés'"
          >{{ formaterCompteur(synthese.totalNouveautes()) }}</span
        >
      }
    </button>
    @if (synthese.erreurNavigation()) {
      <p role="alert">{{ synthese.erreurNavigation() }}</p>
    }
    <div class="user-summary">
      <div class="avatar" [class.avatar-admin]="estAdmin()" aria-hidden="true">
        {{ initialeUtilisateur() }}
      </div>
      <span class="user-name">{{ nomUtilisateur() }}</span>
    </div>
    <app-intervention-acces
      [installationsDisponibles]="installations()"
      [afficherLibelle]="true"
      [calendrier]="true"
      [compteur]="nombreInterventionsAVenir()"
      [infobulle]="tooltipInterventions()"
      [libelle]="tooltipInterventions()"
    />
    <button
      class="logout-button"
      type="button"
      aria-label="Se déconnecter"
      title="Se déconnecter"
      (click)="seDeconnecter()"
    >
      <span class="material-symbols-outlined">logout</span>
    </button>
  </div>
</header>
